import React, { useState } from "react";

export const ProjectEnquiry = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    budget: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleBudgetSelect = (budget: string) => {
    setFormData({ ...formData, budget });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitMessage("");
    setIsSubmitting(true);

    // basic validation
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.message ||
      !formData.budget
    ) {
      setSubmitMessage("Please fill in all required fields");
      setIsSubmitting(false);
      return;
    }

    const payload = {
      name: formData.name,
      company: formData.company,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      budget: formData.budget,
    };

    try {
      const res = await fetch(
        "https://www.yiscotechglobalservices.ng/api/external-contact-us",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data?.message);

      setSubmitMessage("Your project enquiry has been sent successfully 🚀");

      setFormData({
        name: "",
        company: "",
        email: "",
        phone: "",
        budget: "",
        message: "",
      });
    } catch (error) {
      setSubmitMessage(
        "There was an error submitting your enquiry. Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      id="project-enquiries"
      className="h-fit px-[4vw] md:px-[8vw] bg-[#1B1B22] flex flex-col items-center justify-center font-helveticax"
    >
      <div className="flex flex-col md:flex-row md:mr-auto mt-20">
        <div className="md:w-[40vw]">
          <div className="h-fit py-2 flex items-center">
            <hr className=" rotate-180 bg-[#09A7E4] h-[32px] w-[6px] rounded-[50px]" />{" "}
            <div className="text-[#09A7E4] leading-[100%] tracking-[0%] ml-3">
              <span className="font-medium text-[20px]">
                Let’s Build Something
              </span>
              <br />
              <span className="font-bold text-[30px]">Extraordinary</span>
            </div>
          </div>

          <div className="my-5 text-xl leading-[130%] tracking-[0%] font-normal text-[#F0FBFF]">
            Whether you're a startup with a bold vision or an established brand
            ready for reinvention, we’re here to help you design products that
            stand out and scale.
          </div>

          <div className="my-5 text-xl leading-[130%] tracking-[0%] font-normal text-[#F0FBFF]">
            Let’s talk about your project.
          </div>
        </div>

        <div className="text-[#F5F5F5] text-center md:text-left md:ml-[5vw]">
          <div className="text-[25px] leading-[130%] tracking-[0%] font-semibold">
            Contact info
          </div>
          <div className="text-xl leading-[100%] tracking-[0%] mt-10">
            <span className="font-normal">Nigeria</span>
            <br />
            <span className="font-semibold">+234 9049338341</span>
          </div>

          <div className="text-xl leading-[100%] tracking-[0%] my-5">
            United Kingdom <br />
            <span className="font-semibold">+447366355226</span>
          </div>

          <div className="text-xl leading-[100%] tracking-[0%] font-normal">
            Info@cyberpackhq.com
          </div>
        </div>
      </div>
      <hr className="w-full my-10 border-[#565658] border-[1px]" />
      <div className="text-[25px] leading-[130%] tracking-[0%] font-semibold text-left text-[#F0FBFF] w-full">
        Project enquiries
      </div>

      <div className="rounded-[30px] border-[1px] border-[#565658] w-full py-[20px] md:py-[50px] px-[20px] md:px-[51px] mt-10 mb-20">
        <form className="" onSubmit={handleSubmit}>
          <div className="flex flex-col md:flex-row justify-between">
            <div className="md:w-[47%]">
              <div className="text-[#F0FBFF] text-base leading-[130%] tracking-[0%] font-normal">
                Name *
              </div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="h-[44px] bg-[#2A2A2F] text-[#F5F5F5] border-[#EAEAEA] border-[1px] rounded-[10px] w-full px-2 mt-1"
              />
            </div>

            <div className="md:w-[47%]">
              <div className="text-[#F0FBFF] text-base leading-[130%] tracking-[0%] font-normal">
                Company *
              </div>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="h-[44px] bg-[#2A2A2F] text-[#F5F5F5] border-[#EAEAEA] border-[1px] rounded-[10px] w-full px-2 mt-1"
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between mt-5">
            <div className="md:w-[47%]">
              <div className="text-[#F0FBFF] text-base leading-[130%] tracking-[0%] font-normal">
                Email *
              </div>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="h-[44px] bg-[#2A2A2F] text-[#F5F5F5] border-[#EAEAEA] border-[1px] rounded-[10px] w-full px-2 mt-1"
              />
            </div>

            <div className="md:w-[47%]">
              <div className="text-[#F0FBFF] text-base leading-[130%] tracking-[0%] font-normal">
                Phone number *
              </div>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="h-[44px] bg-[#2A2A2F] text-[#F5F5F5] border-[#EAEAEA] border-[1px] rounded-[10px] w-full px-2 mt-1"
              />
            </div>
          </div>

          <div className="w-full mt-5">
            <div className="text-[#F0FBFF] text-base leading-[130%] tracking-[0%] font-normal">
              Budget *
            </div>
            <div className="flex mt-2 overflow-x-auto gap-x-[15px]">
              {[
                "< $50,000",
                "$50,000 - $100,000",
                "$100,000 - $250,000",
                "> $250,000",
                "Can’t reveal",
              ].map((budget, index) => (
                <button
                  type="button"
                  key={budget}
                  onClick={() => handleBudgetSelect(budget)}
                  className={`text-sm md:text-base text-[#F5F5F5] px-5 leading-[100%] tracking-[0%] rounded-[50px] h-[47px] min-w-[25vw] md:min-w-fit ${
                    formData.budget === budget ? "bg-blue-900" : "bg-[#09A7E4]"
                  } hover:bg-blue-950 border-[1px] border-[#EBEBEB]`}
                >
                  {budget}
                </button>
              ))}
            </div>
          </div>

          <div className="w-full mt-5">
            <div className="text-[#F0FBFF] text-base leading-[130%] tracking-[0%] font-normal">
              Tell us about your project *
            </div>

            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="w-full bg-[#2A2A2F] text-[#F5F5F5] border-[#EAEAEA] border-[1px] rounded-[10px] h-[115px] mt-3 p-2"
            ></textarea>
          </div>

          <button
            // type="submit"
            // onClick={(e) => {
            //   e.preventDefault();
            // }}
            disabled={isSubmitting}
            className="bg-[#09A7E4] text-xl leading-[36px] tracking-[0%] font-normal rounded-[30px] h-[50px] text-[#EFEFEF] px-10 mt-5"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>

          {submitMessage && (
            <p className="text-sm text-[#09A7E4] mt-3">{submitMessage}</p>
          )}
        </form>
      </div>
    </section>
  );
};
